module.exports = __webpack_public_path__ + "img/arrow-h-light.76f8d80d.png";